import { AppCard } from '@/layout/AppComponents';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export default function DevelopmentCard({ pvGlobalData }) {
  const { moduleBridgeHex } = useParams();
  const permissionsLevel = useSelector(
    (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level
  );

  return permissionsLevel === 1 ? (
    <AppCard header="Desarrollo" className="mt-3">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="panel panel-info">
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th className="col-lg-6">Código</th>
                        <th className="col-lg-6">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {_.map(pvGlobalData, (value, key) => (
                        <tr>
                          <td>{key}</td>
                          <td>{value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppCard>
  ) : null;
}
